/** @format */

// UI reducer types
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const LOADING_DATA = "LOADING_DATA";
export const STOP_LOADING_DATA = "STOP_LOADING_DATA";
export const STOP_LOADING_UI = "STOP_LOADING_UI";
// Data reducer typese
export const SET_DATA_ERROR = "SET_DATA_ERROR";
export const CLEAR_DATA_ERROR = "CLEAR_DATA_ERROR";
export const SET_DATA_SUCCESS = "SET_DATA_SUCCESS";
export const CLEAR_DATA_SUCCESS = "CLEAR_DATA_SUCCESS";
export const SET_PROFILE_PAGE = "SET_PROFILE_PAGE";
export const RESET_PROFILE_PAGE = "RESET_PROFILE_PAGE";
export const ADD_IDEAS = "ADD_IDEAS";
export const SET_IDEA = "SET_IDEA";
export const LIKE_IDEA = "LIKE_IDEA";
export const UNLIKE_IDEA = "UNLIKE_IDEA";
export const DELETE_IDEA = "DELETE_IDEA";
export const POST_IDEA = "POST_IDEA";
export const EDIT_IDEA = "EDIT_IDEA";
export const SUBMIT_COMMENT = "SUBMIT_COMMENT";
export const SET_COMMENTS = "SET_COMMENTS";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const DELETE_MY_COMMENT = "DELETE_MY_COMMENT";
export const SET_PROJECT = "SET_PROJECT";
export const CLEAR_LOADING_ERRORS = "CLEAR_LOADING_ERRORS";
export const SET_IDEA_USER = "SET_IDEA_USER";
export const SET_COOKIES = "SET_COOKIES";
export const SET_MAP_BOUNDS = "SET_MAP_BOUNDS";
export const SET_INITIAL_MAP_BOUNDS = "SET_INITIAL_MAP_BOUNDS";
